module.exports = {
    'extends': [ 'eslint:recommended' ],

    'env': {
        'node': true,
        'es6': true,
        'mocha': true,
        'jest/globals': true
    },

    'globals': {
        'spyOn': true
    },

    'plugins': [
        'jest'
    ],

    'rules': {
        'keyword-spacing': 'error',
        'space-in-parens': [ 'error', 'always' ],
        'object-curly-spacing': [ 'error', 'always' ],
        'array-bracket-spacing': [ 'error', 'always' ],
        'computed-property-spacing': [ 'error', 'always' ],
        'space-before-blocks': 'error',
        'space-infix-ops': 'error',
        'comma-spacing': [ 'error', {
            'before': false,
            'after': true
        } ],
        'space-unary-ops': [ 'error', {
            'words': true,
            'nonwords': false
        } ],
        'key-spacing': [ 'error', {
            'afterColon': true
        } ],
        'quotes': [ 'error', 'single', {
            'avoidEscape': true
        } ],
        'eol-last': [ 0 ],
        'no-mixed-requires': [ 0 ],
        'no-underscore-dangle': [ 0 ],
        'no-undef': 'error',
        'no-unused-vars': [ 'error', {
            'args': 'none',
            'ignoreRestSiblings': true
        } ],
        'no-var': 'error',
        'no-console': 0,
        'no-case-declarations': 'off',
        'no-class-assign': 0,
        'no-extra-semi': 'error',
        'no-irregular-whitespace': 1,
        'semi': 'error',
        'curly': 'error',
        'template-curly-spacing': [ 'error', 'always' ]
    }
};
